import Fetch from "@/utils/Fetch"
import ObjectToFormData from "@/utils/ObjectToFormData"

export default {
	namespaced: true,
	state() {
		return {
			cities: null,
		}
	},
	mutations: {
		setState(state, {key, value}) {
			if (!(key in state)) return
			state[key] = value
		},
	},
	actions: {
		async requestCities({commit, dispatch}, id) {
			commit('startLoading', 'requestCities', {root: true})
			let response = null

			if(id === 'all') {
				response = await Fetch(`cities/`, {})
			} else {
				const body = ObjectToFormData({distrCenter: id});
				response = await Fetch(`cities/self-delivery/`, {method: 'POST', body})
			}

			if (response.success) {
				commit('setState', {key: 'cities', value: response.data})
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestCities', {root: true})

			return {
				...response.data
			}
		}
	},

	getters: {
		getCities: state => state.cities,
	}
}

